<template>
  <div class="com-nav-home" v-if="show" @click="nav_home_page">
    <i class="el-icon-top"></i>
  </div>
</template>
<script>
export default {
  computed: {
    show() { 
      return this.$route.fullPath.includes('largescreen') 
    }
  },
  methods:{
    nav_home_page(){
      this.$router.replace('/home/homepage')
    }
  }
}
</script>
<style lang="scss">
.com-nav-home {
  position: fixed;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: 1px solid #7b81a578;
  color: #7b81a578;
  z-index: 999;
  font-size: 18px;
  width: 28px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  transition: all 300ms;

  &:hover {
    color: white;
    border-color: white;
  }

}
</style>